import { useDrawerStore } from '@nexelem/drawer';
import { useCallback } from 'react';
import { UseMutationResult } from '@tanstack/react-query';
import { ItemTypeStatus } from '@nexelem/api';
import { ProductDetailsModalNames, useProductDetailsStore } from '../store';

export type HandleClickProductActionProps = {
  readonly clickFunction: UseMutationResult<number, unknown, void>;
  readonly status: ItemTypeStatus;
  readonly modalName?: ProductDetailsModalNames;
};

export const useHandleClickProductAction = () => {
  const onCloseAllDrawerExceptMenu = useDrawerStore((state) => state.onCloseAllDrawerExceptMenu);

  const setIsActionLoading = useProductDetailsStore((state) => state.setIsActionLoading);
  const changeProductStatus = useProductDetailsStore((state) => state.changeStatus);
  const onToggleModal = useProductDetailsStore((state) => state.actions.onToggleModal);

  return useCallback(
    async ({ clickFunction, status, modalName }: HandleClickProductActionProps) => {
      setIsActionLoading(true);
      await clickFunction
        .mutateAsync()
        .then(() => {
          changeProductStatus(status);
          onCloseAllDrawerExceptMenu();
        })
        .finally(() => {
          setIsActionLoading(false);
          if (modalName) {
            onToggleModal(modalName);
          }
        });
    },
    [changeProductStatus, onCloseAllDrawerExceptMenu, onToggleModal, setIsActionLoading],
  );
};
